
import {defineComponent} from 'vue';
import InlineSvg from "@/components/misc/InlineSvg.vue";
import {Collapse} from "bootstrap";

export default defineComponent({
    name: 'Sidebar',
    components:{
        InlineSvg,
        Collapse
    },
    props:{
        show: Boolean,
        menuCat: {
            type: Array,
            default(){
                return []
            }
        },
        topStore: {
            type: Array,
            default(){
                return []
            }
        },
        store: {
            type: Array,
            default(){
                return []
            }
        }
    },
    emits: ['update:show'],
    data(){
        return {
            menu:false,
            cl: '',
            current: ['sub0'],
            open: ['sub1','sub2'],

        }
    },
    watch:{
        show(val){
            this.menu= val
        },
        menu(val){
            this.$emit('update:show',val)
            new Promise( (resolve)=>{setTimeout(resolve, 200) } )
            .then( ()=> {
                this.cl= this.menu ? 'show' : ''
                document.body.style.overflow= this.menu ? 'hidden' : ''
            });
        }
    },
});
